import { render, staticRenderFns } from "./adminPendingPlans.vue?vue&type=template&id=43ea2ea4&"
import script from "./adminPendingPlans.vue?vue&type=script&lang=js&"
export * from "./adminPendingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports